// store/Groups/GroupsReducer.js
import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  success: false,
  error: null,
  groupData: null,       // store saved group response
  groupMembersData: null,
  devotionalData: null,
  videoData: null,
  journalData: null,
  testimonyData: null,
  verseData: null, 
  devotionalsList: [],
  devotionalsLoading: false,
  devotionalsError: null,
  groupDevotionalsData: null,
  groupDevotionalsLoading: false,
  groupDevotionalsError: null,
  groupJournalsData: null,
  groupJournalsLoading: false,
  groupJournalsError: null,
  groupVideosData: null,
  groupVideosLoading: false,
  groupVideosError: null,
  groupCurriculumsData: null,
  groupCurriculumsLoading: false,
  groupCurriculumsError: null,
  groupTestimoniesData: null,
  groupTestimoniesLoading: false,
  groupTestimoniesError: null,
  myGroupsList: [],
  myGroupsLoading: false,
  myGroupsError: null,
  myGroupsSuccess: false,
  
  // Individual operation states
  myCricleGroupsList: [],
  myCricleGroupsLoading: false,
  myCricleGroupsError: null,
  myCricleGroupsSuccess: false,
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case actionTypes.SAVE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case actionTypes.SAVE_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
      case actionTypes.SAVE_GROUP_MEMBERS_REQUEST:
        return {
          ...state,
          loading: true,
          success: false,
          error: null,
        };
  
      case actionTypes.SAVE_GROUP_MEMBERS_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          groupMembersData: action.payload,
        };
  
      case actionTypes.SAVE_GROUP_MEMBERS_FAIL:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload,
        };

        case actionTypes.SAVE_DEVOTIONAL_REQUEST:
            case actionTypes.SAVE_DEVOTIONAL_VIDEO_REQUEST:
            case actionTypes.SAVE_DEVOTIONAL_JOURNAL_REQUEST:
            case actionTypes.SAVE_DEVOTIONAL_TESTIMONY_REQUEST:
            case actionTypes.SAVE_DEVOTIONAL_VERSE_REQUEST:
              return { ...state, loading: true, success: false, error: null };
              
              case actionTypes.SAVE_DEVOTIONAL_SUCCESS:
                return { ...state, loading: false, success: true, devotionalData: action.payload };
              case actionTypes.SAVE_DEVOTIONAL_VIDEO_SUCCESS:
                return { ...state, loading: false, success: true, videoData: action.payload };
              case actionTypes.SAVE_DEVOTIONAL_JOURNAL_SUCCESS:
                return { ...state, loading: false, success: true, journalData: action.payload };
              case actionTypes.SAVE_DEVOTIONAL_TESTIMONY_SUCCESS:
                return { ...state, loading: false, success: true, testimonyData: action.payload };
              case actionTypes.SAVE_DEVOTIONAL_VERSE_SUCCESS:
                return { ...state, loading: false, success: true, verseData: action.payload };

                case actionTypes.SAVE_DEVOTIONAL_SUCCESS:
                    return { ...state, loading: false, success: true, devotionalData: action.payload };
                  case actionTypes.SAVE_DEVOTIONAL_VIDEO_SUCCESS:
                    return { ...state, loading: false, success: true, videoData: action.payload };
                  case actionTypes.SAVE_DEVOTIONAL_JOURNAL_SUCCESS:
                    return { ...state, loading: false, success: true, journalData: action.payload };
                  case actionTypes.SAVE_DEVOTIONAL_TESTIMONY_SUCCESS:
                    return { ...state, loading: false, success: true, testimonyData: action.payload };
                  case actionTypes.SAVE_DEVOTIONAL_VERSE_SUCCESS:
                    return { ...state, loading: false, success: true, verseData: action.payload };

                    case actionTypes.READ_DEVOTIONALS_REQUEST:
                        return {
                          ...state,
                          devotionalsLoading: true,
                          devotionalsError: null,
                          devotionalsList: [],
                        };
                  
                      case actionTypes.READ_DEVOTIONALS_SUCCESS:
                        return {
                          ...state,
                          devotionalsLoading: false,
                          devotionalsList: action.payload?.data || [],
                        };
                  
                      case actionTypes.READ_DEVOTIONALS_FAIL:
                        return {
                          ...state,
                          devotionalsLoading: false,
                          devotionalsError: action.payload,
                          devotionalsList: [],
                        };
                        case actionTypes.SAVE_GROUP_DEVOTIONALS_REQUEST:
      return {
        ...state,
        groupDevotionalsLoading: true,
        groupDevotionalsError: null,
        groupDevotionalsData: null,
      };

    case actionTypes.SAVE_GROUP_DEVOTIONALS_SUCCESS:
      return {
        ...state,
        groupDevotionalsLoading: false,
        groupDevotionalsData: action.payload,
      };

    case actionTypes.SAVE_GROUP_DEVOTIONALS_FAIL:
      return {
        ...state,
        groupDevotionalsLoading: false,
        groupDevotionalsError: action.payload,
        groupDevotionalsData: null,
      };
                  
      case actionTypes.SAVE_GROUP_JOURNALS_REQUEST:
        return {
          ...state,
          groupJournalsLoading: true,
          groupJournalsError: null,
          groupJournalsData: null,
        };
  
      case actionTypes.SAVE_GROUP_JOURNALS_SUCCESS:
        return {
          ...state,
          groupJournalsLoading: false,
          groupJournalsData: action.payload,
        };
  
      case actionTypes.SAVE_GROUP_JOURNALS_FAIL:
        return {
          ...state,
          groupJournalsLoading: false,
          groupJournalsError: action.payload,
          groupJournalsData: null,
        };
        case actionTypes.SAVE_GROUP_VIDEOS_REQUEST:
            return {
              ...state,
              groupVideosLoading: true,
              groupVideosError: null,
              groupVideosData: null,
            };
      
          case actionTypes.SAVE_GROUP_VIDEOS_SUCCESS:
            return {
              ...state,
              groupVideosLoading: false,
              groupVideosData: action.payload,
            };
      
          case actionTypes.SAVE_GROUP_VIDEOS_FAIL:
            return {
              ...state,
              groupVideosLoading: false,
              groupVideosError: action.payload,
              groupVideosData: null,
            };
      
          // NEW: Save Group Curriculums Reducer Cases
          case actionTypes.SAVE_GROUP_CURRICULUMS_REQUEST:
            return {
              ...state,
              groupCurriculumsLoading: true,
              groupCurriculumsError: null,
              groupCurriculumsData: null,
            };
      
          case actionTypes.SAVE_GROUP_CURRICULUMS_SUCCESS:
            return {
              ...state,
              groupCurriculumsLoading: false,
              groupCurriculumsData: action.payload,
            };
      
          case actionTypes.SAVE_GROUP_CURRICULUMS_FAIL:
            return {
              ...state,
              groupCurriculumsLoading: false,
              groupCurriculumsError: action.payload,
              groupCurriculumsData: null,
            };
      
          // NEW: Save Group Testimonies Reducer Cases
          case actionTypes.SAVE_GROUP_TESTIMONIES_REQUEST:
            return {
              ...state,
              groupTestimoniesLoading: true,
              groupTestimoniesError: null,
              groupTestimoniesData: null,
            };
      
          case actionTypes.SAVE_GROUP_TESTIMONIES_SUCCESS:
            return {
              ...state,
              groupTestimoniesLoading: false,
              groupTestimoniesData: action.payload,
            };
      
          case actionTypes.SAVE_GROUP_TESTIMONIES_FAIL:
            return {
              ...state,
              groupTestimoniesLoading: false,
              groupTestimoniesError: action.payload,
              groupTestimoniesData: null,
            };
            case actionTypes.READ_MY_GROUPS_REQUEST:
  return {
    ...state,
    myCricleGroupsLoading: true,
    myCricleGroupsError: null,
    myCricleGroupsSuccess: false,
    myCricleGroupsList: [],
  };

case actionTypes.READ_MY_GROUPS_SUCCESS:
  return {
    ...state,
    myCricleGroupsLoading: false,
    myCricleGroupsSuccess: true,
    myCricleGroupsList: action.payload?.data || [],
  };

case actionTypes.READ_MY_GROUPS_FAIL:
  return {
    ...state,
    myCricleGroupsLoading: false,
    myCricleGroupsSuccess: false,
    myCricleGroupsError: action.payload,
    myCricleGroupsList: [],
  };
    default:
      return state;
  }
};

export default groupsReducer;
